/*
   When Proship creates the fulfillment on Shopify for this merchant's channel orders.

   Backend: POST /api/config/merchant/{id}/updatefield  { field: 'shopifyFulfillmentTrigger', value }
   Read:    GET  /api/config/merchant/{id}  -> merchantConfig.shopifyFulfillmentTrigger

   Values must match ChannelFulfillmentTriggerEnum in proship_mongo. Blank or unknown is
   treated as AWB_GENERATED by the backend, so that is what we show for it. The trigger is
   stamped on each order at AWB time, so a change only affects orders shipped afterwards.
*/
import * as React from 'react';
import { MenuItem, Select } from '@mui/material';
import { useSnackbar } from 'notistack';
import { apiConstants, postGeneric } from '../../../common/constants';
import ConfigRow from '../shared/ConfigRow';

const OPTIONS = [
    { value: 'AWB_GENERATED', label: 'At AWB generation' },
    { value: 'PICKED_UP', label: 'On courier pickup' },
];
const DEFAULT = 'AWB_GENERATED';

export default function ShopifyFulfillmentTrigger({ id, config, setReload }) {
    const { enqueueSnackbar } = useSnackbar();
    const [saving, setSaving] = React.useState(false);

    const stored = config?.shopifyFulfillmentTrigger;
    const current = OPTIONS.some((o) => o.value === stored) ? stored : DEFAULT;

    const onChange = (e) => {
        const next = e.target.value;
        if (next === current) return;
        setSaving(true);
        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${id}/updatefield`, {
            field: 'shopifyFulfillmentTrigger',
            value: next,
        })
            .then(() => {
                enqueueSnackbar('Shopify fulfillment timing updated', { variant: 'success' });
                setReload((r) => r + 1);
            })
            .catch((err) => enqueueSnackbar(
                err?.response?.data?.message || 'Could not update Shopify fulfillment timing. Nothing was changed — try again.',
                { variant: 'error' },
            ))
            .finally(() => setSaving(false));
    };

    return (
        <ConfigRow
            label="Mark Shopify order as fulfilled"
            help="When the fulfillment is created on Shopify. “On courier pickup” waits for the first pickup scan instead of AWB generation. Applies to orders shipped after the change."
            state={current !== DEFAULT ? 'set' : 'unset'}
            control={
                <Select
                    size="small"
                    value={current}
                    onChange={onChange}
                    disabled={saving || !config}
                    sx={{ minWidth: 190, fontSize: 13 }}
                >
                    {OPTIONS.map((o) => (
                        <MenuItem key={o.value} value={o.value} sx={{ fontSize: 13 }}>{o.label}</MenuItem>
                    ))}
                </Select>
            }
        />
    );
}
